import {createErrorHandlingThunk} from "../../../auth/redux/utils";
import {AvailabilityService} from "./AvailibilityService";
import {CreateAvailabilityData, FeAvailability, UpdateAvailabilityInput, UpdateAvailabilityResult} from "./types";

const availabilityService = new AvailabilityService();

export const createAvailabilityThunk = createErrorHandlingThunk<FeAvailability, CreateAvailabilityData>(
    'availability/create',
    (dto) => availabilityService.createAvailability(dto)
);

export const updateAvailabilityThunk = createErrorHandlingThunk<UpdateAvailabilityResult, { id: string, dto: UpdateAvailabilityInput }>(
    'availability/update',
    (args) => availabilityService.updateAvailability(args.id, args.dto)
);

export const listAvailabilitiesThunk = createErrorHandlingThunk(
    'availability/list',
    () => availabilityService.listAvailabilities()
);

export const listWorkerAvailabilities = createErrorHandlingThunk<FeAvailability[], {workerId: string, timeRange?: {start: number, end: number}}>(
    'availability/worker/list',
    (args) =>  availabilityService.listWorkerAvailabilities(args.workerId, args.timeRange)
)

export const getAvailabilityThunk = createErrorHandlingThunk<FeAvailability, {id: string}>(
    'availability/get',
    (args) => availabilityService.getAvailability(args.id)
);

export const deleteAvailabilityThunk = createErrorHandlingThunk<string, {id: string}>(
    'availability/delete',
    (args) => availabilityService.deleteAvailability(args.id)
);
